import { FilterSubCategory } from "@/types/home";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StepState {
  currentStep: number;
  step: number;
  selectedBrand: string | null;
  selectedFilters: FilterSubCategory[];
  creditOpen: boolean;
  walletOpen: boolean;
}

const initialState: StepState = {
  currentStep: 1,
  step: 1,
  selectedBrand: null,
  selectedFilters: [],
  creditOpen: false,
  walletOpen: false,
};

const stepSlice = createSlice({
  name: "steps",
  initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setCreditOpen: (state, action: PayloadAction<boolean>) => {
      state.creditOpen = action.payload;
    },
    setWalletOpen: (state, action: PayloadAction<boolean>) => {
      state.walletOpen = action.payload;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setSelectedBrand: (state, action: PayloadAction<string>) => {
      state.selectedBrand = action.payload;
    },
    setSelectedFilters: (state, action: PayloadAction<FilterSubCategory[]>) => {
      state.selectedFilters = action.payload;
    },
    addFilter: (state, action: PayloadAction<FilterSubCategory>) => {
      state.selectedFilters.push(action.payload);
    },
    removeFilter: (state, action: PayloadAction<number>) => {
      state.selectedFilters = state.selectedFilters.filter(
        (filter) => filter.sc_id !== action.payload
      );
    },
    clearFilters: (state) => {
      state.selectedFilters = [];
    },
  },
});

export const {
  setCurrentStep,
  setCreditOpen,
  setWalletOpen,
  setStep,
  setSelectedBrand,
  setSelectedFilters,
  addFilter,
  removeFilter,
  clearFilters,
} = stepSlice.actions;
export default stepSlice.reducer;
